<template>
  <span class="radio-button-custom">
    <template v-for="op in options">
      <span
        class="radio-button-custom__button"
        :key="op.value">
        <input
          type='radio'
          class="radio-button-custom__radio"
          :name='radioButtonName'
          :id="op.name"
          :checked="String(value) === String(op.value)"
          @input="emitInput"
          :value="op.value"
          :disabled="disabled"
        >
        <label :for="op.name">{{op.name}}</label>
      </span>
    </template>
  </span>
</template>

<script>

function makeid (x) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < x; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}
/**
 * v-modal on selected
 * options - {value, name}
 */
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: null
    },
    onSelect: {
      type: Function,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      defautl: false
    }
  },
  data () {
    return {
      radioButtonName: null
    }
  },
  beforeMount () {
    this.radioButtonName = this.name ? this.name : makeid(15)
  },
  methods: {
    emitInput (e) {
      this.$emit('input', e.target.value)
      this.onSelect()
    }
  }
}
</script>

<style lang='scss'>
.radio-button-custom {
  &__button {
    margin-right: 10px;
  }
  &__radio {
    margin-right: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// RadioButton.vue?6ad35b1b